import type {DecorationPlugin} from '../../types'
import {pack} from './pack'
import {unpack} from './unpack'

export const variantsPlugin = {
    name: 'VariantsPlugin',
    pack,
    unpack
} satisfies DecorationPlugin
